import { Link } from "react-router-dom";
import { formatNewsTime } from "@/utils/format";
import type { NewsItem } from "@/types";

type NewsCardProps = {
  item: NewsItem;
  variant?: "list" | "grid";
};

export default function NewsCard({ item, variant = "list" }: NewsCardProps) {
  if (variant === "grid") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
      >
        <div className="w-full h-44 overflow-hidden bg-background-100">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 篮球资讯`}
            className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex flex-col flex-1 p-4 md:p-5">
          <span className="self-start text-[11px] font-label font-semibold px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 mb-2">
            {item.category}
          </span>
          <h3 className="font-heading text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {item.summary}
          </p>
          <div className="mt-auto pt-3 flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line" />
              {item.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" />
              {formatNewsTime(item.publishTime)}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="hidden sm:block w-40 md:w-48 h-28 shrink-0 rounded-md overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 篮球资讯`}
          className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="min-w-0 flex-1 flex flex-col">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="text-[11px] font-label font-semibold px-2 py-0.5 rounded bg-secondary-100 text-secondary-800">
            {item.category}
          </span>
          <span className="text-xs text-foreground-500">{formatNewsTime(item.publishTime)}</span>
        </div>
        <h3 className="font-heading text-base md:text-lg text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2 hidden sm:block">
          {item.summary}
        </p>
        <div className="mt-auto pt-2 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" />
            {item.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line" />
            约 {item.readTime} 分钟
          </span>
        </div>
      </div>
    </Link>
  );
}